ux-w-status {
    display: inline-block;

    // fix for duplicated icons after cloning the element
    .ux-w-status__text ux-icon {
        display: none;
    }
}

.ux-w-status__text--neutral {
    color: #000;
    text-transform: none;
    font-weight: normal;
    font-family: var(--ux-font);
}
